import classNames from 'classnames';
import Button from '../../components/Button/Button';
import ButtonGroup from '../../components/ButtonGroup/ButtonGroup';
import Sizing from '../../types/enum/Sizing';
import './SegmentedControl.scss';
import ISegmentedControlProps from './SegmentedControlProps';

function SegmentedControl<T>({ options, onChange, value, sizing, disabled, className }: ISegmentedControlProps<T>) {
  function handleClick(val: T) {
    if (!disabled) {
      onChange(val);
    }
  }

  function renderButtons() {
    const segments = options.map((option, index) => {
      let type: 'secondary' | 'primary' = 'secondary';
      if (value !== undefined && option.value === value) {
        type = 'primary';
      }

      function onClick() {
        handleClick(option.value);
      }

      return (
        <Button key={index} type={type} disabled={disabled} onClick={onClick}>
          {option.label}
        </Button>
      );
    });

    return segments;
  }

  return (
    <ButtonGroup className={classNames('segmented-control', className)} sizing={sizing}>
      {renderButtons()}
    </ButtonGroup>
  );
}

SegmentedControl.defaultProps = {
  sizing: Sizing.FIXED,
  disabled: false,
};

export default SegmentedControl;
